var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecondaryBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1389,
    height: 727,
    viewBox: "0 0 1389 727",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_104_87",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1400,
    height: 727
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1400V727H0V0Z",
    fill: "#F5F7FC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_104_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M821.732 443.377L619.495 584.068L595.843 548.899L149.048 676.402L821.732 443.377Z",
    fill: "#FCE9D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.026 707.175L821.732 443.377L619.495 584.068L595.843 548.899L149.048 676.402L509.576 623.634L595.843 676.402L694.229 636.837L735.026 707.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.803 628.015C985.227 628.015 971.218 622.989 952.813 615.662C951.347 615.105 924.062 542.715 924.062 542.715L948.006 615.017L939.8 611.193L928.648 580.214L937.441 611.354L932.077 608.687L924.428 582.955L931.022 608.599L821.734 559.875L821.734 632.411L801.922 667.581L779.619 707.146L756.847 747.576L838.996 667.581L852.185 610.694L872.817 610.694L872.817 590.941L948.9 637.101L1019.24 707.146L1098.37 729.376L1294 771.139L1017.77 588.714L992.862 615.091L988.803 628.015Z",
    fill: "#EAD4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.52 765.395L1394.46 765.395L1387.52 707.967L1380.59 765.395L1387.52 765.395Z",
    fill: "#8B86D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.64 771.169L1380.59 771.169L1373.64 679.26L1366.69 771.169L1373.64 771.169Z",
    fill: "#8B86D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1352.82 772.722L1359.76 772.722L1352.82 715.294L1345.89 772.722L1352.82 772.722Z",
    fill: "#8B86D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.69 771.169L1373.64 771.169L1366.69 702.838L1359.76 771.169L1366.69 771.169Z",
    fill: "#8B86D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338.94 776.459L1345.89 776.459L1338.94 686.587L1331.99 776.459L1338.94 776.459Z",
    fill: "#8B86D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338.94 774.48L1345.89 774.48L1338.94 711.498L1331.99 774.48L1338.94 774.48Z",
    fill: "#8B86D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1481.33 554.171L1333.42 482.191L846.85 747.601L450.874 772.879L218.142 565.176L135.157 605.371C98.0617 623.338 55.5427 626.605 16.1384 614.515L-144.643 565.176L-394.36 826.732L-394.36 1275.14L1481.33 1275.14L1481.33 554.171Z",
    fill: "#F0F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.8 478.547L1199.85 614.842L821.732 443.377L149.048 676.403L-48.662 627.488L-202.674 526.919L-401.893 417L-401.893 540.107L-401.893 1269.88L1473.8 1269.88L1473.8 478.547Z",
    fill: "#F0F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1473.8 759.929L1428.46 606.049L1358.12 676.403L1358.12 707.176L1277.42 735.238L843.713 476.905L821.732 559.89L821.732 632.426L735.025 786.321L685.437 707.176L619.495 742.345L549.698 714.796L632.448 618.491L530.384 707.176L498.058 694.412L691.064 559.89L466.508 681.956L452.426 676.402L74.313 742.345L-6.64957 721.522L32.3736 774.481L-15.2074 719.324L-28.9379 715.792L38.2352 795.274L-37.95 716.876L-48.662 713.272L-20.3654 767.154L-56.9999 711.748L-233.447 663.214L-401.893 509.334L-401.893 1269.88L1473.8 1269.88L1473.8 873.394L1473.8 759.929Z",
    fill: "#F8FAFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryBg);
export default __webpack_public_path__ + "static/media/Secondary_BG.a90d13b5a991b22a9452c115e519cb02.svg";
export { ForwardRef as ReactComponent };